export const GLOBAL_LABELS = 'global';

// global plccForm
export const lblPLCCInterested = 'lbl_PLCC_interested';

// global emailSignup
export const lblNoThanks = 'lbl_no_thanks';

// global minibag
export const lblMiniBagHi = 'lbl_miniBag_hi';

// global accountDrawer
export const lblAccountDrawerMyPlaceRewardsCC = 'lbl_accountDrawer_myPlaceRewardsCC';

const GlobalRtpsModalLabels = {
  global: {
    plccForm: {
      [lblPLCCInterested]: "Yes, I'm Interested",
    },
    emailSignup: {
      [lblNoThanks]: 'No Thanks',
    },
    minibag: {
      [lblMiniBagHi]: 'Hi',
    },
    accountDrawer: {
      [lblAccountDrawerMyPlaceRewardsCC]: 'My Place Rewards Credit Card',
    },
  },
};
export default GlobalRtpsModalLabels;
